import { Component, OnInit } from '@angular/core';
import { ModalController } from "@ionic/angular";

@Component({
  selector: 'app-feature-explanation-popup',
  templateUrl: './feature-explanation-popup.component.html',
  styleUrls: ['./feature-explanation-popup.component.scss'],
})
export class FeatureExplanationPopupComponent implements OnInit {
  featureItem;
  constructor(public modalController: ModalController) { }

  ngOnInit() {}

  close() {
    let data = {};
    this.modalController.dismiss(data);
  }

}
